// extracted by mini-css-extract-plugin
export default {"productGrid":"qZ-z","centerLink":"rZ-z","productSection":"sZ-z","item":"tZ-z","ctaButton":"uZ-z"};